import { useRef, useState } from "react";
import {
  AtButtonProps,
  CSCFooterDrawer,
  OrDrawer,
  OrForm,
  OrFormRef,
} from "@csc-dashboard/components-library";
import { useAdminPanel } from "../context/admin-panel";

export const NoteForm = () => {
  const { isLoading, createNote, editNote, setCurrentTab, tabParams } =
    useAdminPanel();
  const formRef = useRef<OrFormRef>(null);
  const [disabled, setDisabled] = useState(true);

  // Extract noteId and noteBody from tabParams
  const noteId = tabParams?.noteId as string | undefined;
  const noteBody = tabParams?.noteBody as string | undefined;
  const isEditing = !!noteId;

  const initialValues = {
    note: noteBody || "",
  };

  const buttons: AtButtonProps[] = [
    {
      text: isEditing ? "Actualizar nota" : "Guardar nota",
      disabled,
      loading: isLoading,
      onClick: () => formRef.current?.submit(),
    },
    {
      text: "Regresar",
      disabled: isLoading,
      onClick: () => setCurrentTab("notes"),
    },
  ];

  const onSubmit = (values: Record<string, unknown>) => {
    if (isEditing) {
      editNote({ noteId: noteId, noteBody: values.note as string });
    } else {
      createNote({ noteBody: values.note as string });
    }
  };

  return (
    <>
      <OrDrawer.Content>
        <div className="p-2">
          <OrForm
            ref={formRef}
            data-testid="register-new-agent-form"
            initialValues={initialValues}
            onSubmit={onSubmit}
            onStateChange={({ disabled }) => setDisabled(disabled)}
          >
            <OrForm.TextArea
              label="Escribe tu nota"
              name="note"
              helpText="No puede exceder los 5000 caracteres."
              validation={{
                required: "Este campo es obligatorio",
                max: {
                  value: 5000,
                  message: "No puede exceder los 5000 caracteres.",
                },
              }}
            ></OrForm.TextArea>
          </OrForm>
        </div>
      </OrDrawer.Content>
      <OrDrawer.Footer>
        <CSCFooterDrawer
          mainButton={buttons[0] as AtButtonProps}
          secondaryButton={buttons[1]}
        />
      </OrDrawer.Footer>
    </>
  );
};
